import React, { useState, useEffect } from "react";
import "video-react/dist/video-react.css"; // Required for video-react styles

const LazyVideoPlayer = ({ videoUrl, setLoading, onEnded }) => {
  const [Player, setPlayer] = useState(null);

  useEffect(() => {
    const loadPlayer = async () => {
      const { Player } = await import("video-react");
      setPlayer(() => Player);
      setLoading(true); // Show loader while the player is loading
    };

    loadPlayer();
  }, [setLoading]);

  return (
    <div style={{ position: "relative", textAlign: "center" }}>
      {Player && (
        <Player
          src={videoUrl}
          onCanPlay={() => setLoading(false)} // Hide loader when ready
          onWaiting={() => setLoading(true)} // Show loader when buffering
          onEnded={onEnded} // Trigger parent onEnded handler
        />
      )}
      <div
        style={{
          marginTop: "10px",
          fontSize: "12px",
          color: "#888",
        }}
      >
        PFTP Video Server
      </div>
    </div>
  );
};

export default LazyVideoPlayer;
